module.exports = __webpack_public_path__ + "img/about-logo.1c27fa2b.png";